import { Component, Input } from '@angular/core';
import { IconSize } from '../../core-data-model/IconSize';

@Component({
    selector: 'speech-bubble-icon',
    template: `
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            attr.width="{{ iconSize }}"
            attr.height="{{ iconSize }}"
            version="1.1"
        >
            <defs>
                <path
                    d="M0,53 C0,82.271 23.729,106 53,106 L53,106 C82.271,106 106,82.271 106,53 L106,53 C106,23.729 82.271,0 53,0 L53,0 C23.729,0 0,23.729 0,53 L0,53 Z"
                    id="ig-path-1"
                />
            </defs>
            <g
                id="ig-Person-Page-"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
            >
                <g
                    id="ig-B-Person-page--more-people-added-"
                    transform="translate(-366.000000, -2382.000000)"
                >
                    <g
                        id="ig-Group-28"
                        transform="translate(368.000000, 2384.000000)"
                    >
                        <g id="ig-Group-20">
                            <g id="ig-Group-23">
                                <path
                                    d="M53,106 C82.271,106 106,82.271 106,53 C106,23.729 82.271,0 53,0 C23.729,0 0,23.729 0,53 C0,82.271 23.729,106 53,106 Z"
                                    id="ig-Stroke-1"
                                    stroke="#0092C8"
                                    stroke-width="2.4"
                                />
                                <g id="ig-Group-6">
                                    <mask id="ig-mask-2" fill="white">
                                        <use xlink:href="#ig-path-1" />
                                    </mask>
                                    <g id="ig-Clip-4" />
                                    <polygon
                                        id="ig-Fill-3"
                                        fill="#F3FBFE"
                                        mask="url(#ig-mask-2)"
                                        points="-5 111 111 111 111 -5 -5 -5"
                                    />
                                    <path
                                        class="svgWrapperShape"
                                        d="M53,106 C82.271,106 106,82.271 106,53 C106,23.729 82.271,0 53,0 C23.729,0 0,23.729 0,53 C0,82.271 23.729,106 53,106 Z"
                                        id="ig-Stroke-5"
                                        stroke="#0092C8"
                                        stroke-width="6.4"
                                        mask="url(#ig-mask-2)"
                                    />
                                </g>
                            </g>
                            <path
                                d="M42,49 L63,49 L63,47 L42,47 L42,49 Z M42,54 L58,54 L58,52 L42,52 L42,54 Z M66.288232,36 L39.711768,36 C35.4700331,36 32,39.4936076 32,43.7641597 L32,73 L39.8745078,65.0719949 L66.288232,65.0719949 C70.5299669,65.0719949 74,61.5783873 74,57.3078352 L74,43.7641597 C74,39.4936076 70.5299669,36 66.288232,36 L66.288232,36 Z"
                                id="ig-Fill-1"
                                fill="#3D1C70"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    `,
    standalone: false
})
export class SpeechBubbleIconComponent {
    @Input()
    iconSize: IconSize;
}
